// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#PageFilters {
  width: 100vw !important;
  padding: 0;
  margin: 0;
}
#PageFilters .Filters {
  overflow-x: auto;
  white-space: nowrap;
  flex-wrap: nowrap;
  border: 0 !important;
}
#PageFilters .Filters * {
  white-space: nowrap;
  flex-wrap: nowrap;
}
#PageFilters .Filters .DateRangePicker .ant-picker {
  max-width: 140px;
}
#PageFilters .Filters .FormField-Wrapper {
  overflow: hidden;
}
#PageFilters .Filters .FormField,
#PageFilters .Filters *:not(.FormField-Wrapper) > .form-control,
#PageFilters .Filters *:not(.FormField-Wrapper) > .dropdown,
#PageFilters .Filters .Dropdown {
  flex: 1 0 0 !important;
  min-width: 75px;
  max-width: 140px;
}
#PageFilters .Filters .FormField.w-100,
#PageFilters .Filters *:not(.FormField-Wrapper) > .form-control.w-100,
#PageFilters .Filters *:not(.FormField-Wrapper) > .dropdown.w-100,
#PageFilters .Filters .Dropdown.w-100 {
  width: auto !important;
}
#PageFilters .Filters .FormField.w-100 .btn > span,
#PageFilters .Filters *:not(.FormField-Wrapper) > .form-control.w-100 .btn > span,
#PageFilters .Filters *:not(.FormField-Wrapper) > .dropdown.w-100 .btn > span,
#PageFilters .Filters .Dropdown.w-100 .btn > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#PageFilters .Filters .FormField.DateRange,
#PageFilters .Filters *:not(.FormField-Wrapper) > .form-control.DateRange,
#PageFilters .Filters *:not(.FormField-Wrapper) > .dropdown.DateRange,
#PageFilters .Filters .Dropdown.DateRange {
  min-width: auto !important;
  max-width: 280px !important;
}
#PageFilters .Filters .FormField.DateRange .ant-picker,
#PageFilters .Filters *:not(.FormField-Wrapper) > .form-control.DateRange .ant-picker,
#PageFilters .Filters *:not(.FormField-Wrapper) > .dropdown.DateRange .ant-picker,
#PageFilters .Filters .Dropdown.DateRange .ant-picker {
  max-width: 140px !important;
}
#PageFilters .Filters .FormField.WeekInput,
#PageFilters .Filters *:not(.FormField-Wrapper) > .form-control.WeekInput,
#PageFilters .Filters *:not(.FormField-Wrapper) > .dropdown.WeekInput,
#PageFilters .Filters .Dropdown.WeekInput {
  min-width: auto !important;
  max-width: 180px !important;
}
#PageFilters .Filters .FormField.WeekInput .ant-picker,
#PageFilters .Filters *:not(.FormField-Wrapper) > .form-control.WeekInput .ant-picker,
#PageFilters .Filters *:not(.FormField-Wrapper) > .dropdown.WeekInput .ant-picker,
#PageFilters .Filters .Dropdown.WeekInput .ant-picker {
  max-width: 180px !important;
}
#PageFilters .Filters::-webkit-scrollbar-track {
  background: var(--bs-primary);
}
#PageFilters .Filters::-webkit-scrollbar-thumb {
  background-color: var(--bs-light);
  border: 2px solid var(--bs-primary);
}
#PageFilters .Filters .ActionsDropdown button {
  position: absolute;
  right: -0.75rem;
  padding-right: 0;
}
#PageFilters .Filters .ActionsDropdown button i {
  font-size: 1.5rem;
}
#PageFilters .Filters .ActionsDropdown .fa-ellipsis-v {
  font-size: 2rem;
}
#PageFilters .FormField *.hasValue::placeholder {
  color: var(--bs-secondary-subtle) !important;
}
#PageFilters .FormField.is-dirty *::placeholder {
  color: var(--bs-secondary) !important;
}
#PageFilters .FormField.is-dirty .form-control,
#PageFilters .FormField.is-dirty .ant-picker,
#PageFilters .FormField.is-dirty .ant-picker input,
#PageFilters .FormField.is-dirty .ant-picker i {
  border-color: var(--bs-secondary) !important;
  color: var(--bs-secondary) !important;
}
#PageFilters .ActiveSwitch {
  align-self: center;
  margin-right: 1rem;
}
#PageFilters .ActiveSwitch.form-check-reverse .form-check-label {
  margin-right: 1rem;
}

#PageSettings .modal-body[title]:before {
  position: relative;
  display: block;
  width: 100%;
  padding-bottom: 0.25rem;
  margin-bottom: 0.5rem;
  text-align: center;
  font-size: 1.5rem;
  border-bottom: 1px solid #ccc;
  content: attr(title);
}
#PageSettings .modal-body + .group-controls {
  padding-top: 0;
}
#PageSettings .modal-body:empty:not(.static), #PageSettings .modal-body:empty:not(.static) + .group-controls {
  display: none;
}

.RouteContent .Filters {
  overflow-x: auto;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
.RouteContent .Filters .Dropdown,
.RouteContent .Filters .Input {
  min-width: 6rem;
  max-width: 10rem;
}
.RouteContent .Filters .Dropdown + [name=SUBMIT_SEARCH],
.RouteContent .Filters .Input + [name=SUBMIT_SEARCH] {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Filters/styles.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,UAAA;EACA,SAAA;AACF;AAAE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAEJ;AADI;EACE,mBAAA;EACA,iBAAA;AAGN;AAAM;EACE,gBAAA;AAER;AACI;EACE,gBAAA;AACN;AACI;;;;EAIE,sBAAA;EACA,eAAA;EACA,gBAAA;AACN;AAAM;;;;EACE,sBAAA;AAKR;AAJQ;;;;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;AASV;AANM;;;;EACE,0BAAA;EACA,2BAAA;AAWR;AAVQ;;;;EACE,2BAAA;AAeV;AAZM;;;;EACE,0BAAA;EACA,2BAAA;AAiBR;AAhBQ;;;;EACE,2BAAA;AAqBV;AAjBI;EACE,6BAAA;AAmBN;AAjBI;EACE,iCAAA;EACA,mCAAA;AAmBN;AAjBI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAmBN;AAlBM;EACE,iBAAA;AAoBR;AAjBI;EACE,eAAA;AAmBN;AAfI;EACE,4CAAA;AAiBN;AAdM;EACE,qCAAA;AAgBR;AAdM;;;;EAIE,4CAAA;EACA,qCAAA;AAgBR;AAZE;EACE,kBAAA;EACA,kBAAA;AAcJ;AAZM;EACE,kBAAA;AAcR;;AAPI;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,oBAAA;AAUN;AARI;EACE,cAAA;AAUN;AARI;EAEE,aAAA;AASN;;AAJE;EACE,gBAAA;EACA,6CAAA;AAOJ;AANI;;EAEE,eAAA;EACA,gBAAA;AAQN;AAPM;;EACE,iBAAA;AAUR","sourcesContent":["#PageFilters {\n  width: 100vw !important;\n  padding: 0;\n  margin: 0;\n  .Filters {\n    overflow-x: auto;\n    white-space: nowrap;\n    flex-wrap: nowrap;\n    border: 0 !important;\n    * {\n      white-space: nowrap;\n      flex-wrap: nowrap;\n    }\n    .DateRangePicker {\n      .ant-picker {\n        max-width: 140px;\n      }\n    }\n    .FormField-Wrapper {\n      overflow: hidden;\n    }\n    .FormField,\n    *:not(.FormField-Wrapper) > .form-control,\n    *:not(.FormField-Wrapper) > .dropdown,\n    .Dropdown {\n      flex: 1 0 0 !important;\n      min-width: 75px;\n      max-width: 140px;\n      &.w-100 {\n        width: auto !important;\n        .btn > span {\n          overflow: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n        }\n      }\n      &.DateRange {\n        min-width: auto !important;\n        max-width: 280px !important;\n        .ant-picker {\n          max-width: 140px !important;\n        }\n      }\n      &.WeekInput {\n        min-width: auto !important;\n        max-width: 180px !important;\n        .ant-picker {\n          max-width: 180px !important;\n        }\n      }\n    }\n    &::-webkit-scrollbar-track {\n      background: var(--bs-primary);\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: var(--bs-light);\n      border: 2px solid var(--bs-primary);\n    }\n    .ActionsDropdown button {\n      position: absolute;\n      right: -0.75rem;\n      padding-right: 0;\n      i {\n        font-size: 1.5rem;\n      }\n    }\n    .ActionsDropdown .fa-ellipsis-v {\n      font-size: 2rem;\n    }\n  }\n  .FormField {\n    *.hasValue::placeholder {\n      color: var(--bs-secondary-subtle) !important;\n    }\n    &.is-dirty {\n      *::placeholder {\n        color: var(--bs-secondary) !important;\n      }\n      .form-control,\n      .ant-picker,\n      .ant-picker input,\n      .ant-picker i {\n        border-color: var(--bs-secondary) !important;\n        color: var(--bs-secondary) !important;\n      }\n    }\n  }\n  .ActiveSwitch {\n    align-self: center;\n    margin-right: 1rem;\n    &.form-check-reverse {\n      .form-check-label {\n        margin-right: 1rem;\n      }\n    }\n  }\n}\n#PageSettings {\n  .modal-body {\n    &[title]:before {\n      position: relative;\n      display: block;\n      width: 100%;\n      padding-bottom: 0.25rem;\n      margin-bottom: 0.5rem;\n      text-align: center;\n      font-size: 1.5rem;\n      border-bottom: 1px solid #ccc;\n      content: attr(title);\n    }\n    + .group-controls {\n      padding-top: 0;\n    }\n    &:empty:not(.static),\n    &:empty:not(.static) + .group-controls {\n      display: none;\n    }\n  }\n}\n.RouteContent {\n  .Filters {\n    overflow-x: auto;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    .Dropdown,\n    .Input {\n      min-width: 6rem;\n      max-width: 10rem;\n      + [name='SUBMIT_SEARCH'] {\n        margin-left: auto;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
